// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__O2aPm","notes":"Notes_notes__38aqd","note":"Notes_note__1kxjC","markdown":"Notes_markdown___O9NB"};